import { Injectable } from '@angular/core';
import { NewsDetails, NewsSummary } from '@app/news/models';
import { HttpService } from '@core/services';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class NewsService {
  constructor(private http: HttpService) {}

  getNews(): Observable<NewsSummary[]> {
    return this.http.get(`/public/News`);
  }

  getNewsDetails(id: number): Observable<NewsDetails> {
    return this.http.get(`/public/News/${id}`);
  }
}
